import { FunctionalComponent, h } from 'preact';
import { FinText } from '../../../../i18n';
import { NBSP, Properties } from '../../../../common';
import { WithStyles, withStyles } from '../../../../style';
import { isNotPresent, isPresent } from '../../../../utils/typeUtils';
import { range } from '../../paxAmountUtils';
import * as styles from './AgeSelect.scss';

export interface AgeSelectProps extends Properties {
  childId: number;
  value: number;
  onAgeChange: (value: number) => void;
  disableInfants: boolean;
}

type EffectiveProps = AgeSelectProps & WithStyles;

export const AgeSelect: FunctionalComponent<AgeSelectProps> = withStyles(styles)(
  ({ tx, childId, value, onAgeChange, disableInfants }: EffectiveProps) => (
    <div class={tx('relative mr-xsmall-b fill')}>
      <div class={tx('label', 'capitalize absolute font-body-1')}>
        <FinText id="paxAmount.children.one" /> {childId}
      </div>
      <select
        class={tx('field', 'border grey-600-border rounded-medium fill white-bg regular-type font-body-1', {
          'nordic-blue-900-text': isPresent(value),
          'grey-600-text': isNotPresent(value),
        })}
        value={value}
        onChange={(e) => onAgeChange(Number((e.target as HTMLSelectElement).value))}
      >
        <option value="" disabled selected>
          <FinText id="aurinkomatkat.paxAmount.selectAge" />
        </option>
        {range(0, 18).map((age: number, i: number) => (
          <option key={age} value={age} disabled={disableInfants && i < 2}>
            {age} <FinText id={`aurinkomatkat.paxAmount.${age === 1 ? 'year' : 'years'}`} />
            {disableInfants && i < 2 && [NBSP, '(', <FinText key={age} id="paxAmountModal.add.adults" />, ')']}
          </option>
        ))}
      </select>
    </div>
  )
);
